var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"icon-button",attrs:{"type":"button","disabled":_vm.disabled}},_vm.$listeners),[_c('font-awesome-icon',{class:_vm.iconClass,attrs:{"icon":_vm.icon,"size":_vm.size}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f29d9f78","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/sba-icon-button.vue
// module id = null
// module chunks = 